import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Breadcrumb } from './breadcrumb.interfaces';
import { BreadcrumbService } from './breadcrumb.service';

@Component({
    standalone: false,
    selector: 'breadcrumb',
    template: '<ng-content></ng-content>'
})
export class BreadcrumbComponent implements OnInit, OnDestroy {
    breadcrumbs: Breadcrumb[] = [];
    private subscription: Subscription;

    constructor(private breadcrumbService: BreadcrumbService) {}

    ngOnInit(): void {
        this.subscription = this.breadcrumbService.breadcrumbChanged.subscribe(
            (crumbs: Breadcrumb[]) => {
                this.breadcrumbs = crumbs;
            }
        );
    }

    ngOnDestroy(): void {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
}
